import { Feature } from './feature';
import { PlanPrice } from './planPrice';

export interface FeatureConfig {
  key: string;
  feature: Feature;
  planName: string;
  quotaType: string;
  annualPrice: number;
  monthlyPrice: number;
}

export const createFeatures = (flags?: {
  subscriptionPlanPrice?: {
    kseAnnually?: number;
    kseMonthly?: number;
    kreAnnually?: number;
    kreMonthly?: number;
    testCloudDesktopAnnually?: number;
    testCloudDesktopMonthly?: number;
    testCloudCrossBrowserAnnually?: number;
    testCloudCrossBrowserMonthly?: number;
    testCloudMobileAnnually?: number;
    testCloudMobileMonthly?: number;
    testCloudLiveTestingAnnually?: number;
    testCloudLiveTestingMonthly?: number;
    visualTestingProAnnually?: number;
    visualTestingProMonthly?: number;
  };
}): FeatureConfig[] => [
  {
    key: 'platform',
    feature: Feature.TESTOPS_PLATFORM,
    planName: 'subscriptions.testops_platform.testops_platform',
    quotaType: 'dashboard.test_execution_chart',
    annualPrice: 399,
    monthlyPrice: 41,
  },
  {
    key: 'kse',
    feature: Feature.PER_USER_KSE,
    planName: 'subscriptions.kse.title',
    quotaType: 'subscriptions.testops_platform.no_licenses',
    annualPrice: flags?.subscriptionPlanPrice?.kseAnnually ?? PlanPrice.KSE_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.kseMonthly ?? PlanPrice.KSE_MONTHLY,
  },
  {
    key: 'kre',
    feature: Feature.UNLIMITED_ENGINE,
    planName: 'subscriptions.kre.title',
    quotaType: 'subscriptions.testops_platform.no_licenses',
    annualPrice: flags?.subscriptionPlanPrice?.kreAnnually ?? PlanPrice.KRE_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.kreMonthly ?? PlanPrice.KRE_MONTHLY,
  },
  {
    key: 'testCloudDesktop',
    feature: Feature.TESTCLOUD_SESSION_WEB_DESKTOP,
    planName: 'subscriptions.test_cloud_desktop.title',
    quotaType: 'subscriptions.testops_platform.no_sessions',
    annualPrice: flags?.subscriptionPlanPrice?.testCloudDesktopAnnually
      ?? PlanPrice.TESTCLOUD_DESKTOP_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.testCloudDesktopMonthly
      ?? PlanPrice.TESTCLOUD_DESKTOP_MONTHLY,
  },
  {
    key: 'testCloudCrossBrowse',
    feature: Feature.TESTCLOUD_SESSION_CROSS_BROWSER,
    planName: 'subscriptions.test_cloud_cross_browser.title',
    quotaType: 'subscriptions.testops_platform.no_sessions',
    annualPrice: flags?.subscriptionPlanPrice?.testCloudCrossBrowserAnnually
      ?? PlanPrice.TESTCLOUD_CROSS_BROWSER_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.testCloudCrossBrowserMonthly
      ?? PlanPrice.TESTCLOUD_CROSS_BROWSER_MONTHLY,
  },
  {
    key: 'testCloudMobile',
    feature: Feature.TESTCLOUD_SESSION_MOBILE_APP,
    planName: 'subscriptions.test_cloud_mobile.title',
    quotaType: 'subscriptions.testops_platform.no_sessions',
    annualPrice: flags?.subscriptionPlanPrice?.testCloudMobileAnnually
      ?? PlanPrice.TESTCLOUD_MOBILE_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.testCloudMobileMonthly
      ?? PlanPrice.TESTCLOUD_MOBILE_MONTHLY,
  },
  {
    key: 'testCloudLiveTesting',
    feature: Feature.TESTCLOUD_SESSION_LIVE_TESTING,
    planName: 'subscriptions.test_cloud_livetesting.title',
    quotaType: 'subscriptions.testops_platform.no_sessions',
    annualPrice: flags?.subscriptionPlanPrice?.testCloudLiveTestingAnnually
      ?? PlanPrice.TESTCLOUD_LIVE_TESTING_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.testCloudLiveTestingMonthly
      ?? PlanPrice.TESTCLOUD_LIVE_TESTING_MONTHLY,
  },
  {
    key: 'visualTesting',
    feature: Feature.VISUAL_TESTING_PRO,
    planName: 'subscriptions.visual_testing.title',
    quotaType: 'subscriptions.testops_platform.no_checkpoint_images',
    annualPrice: flags?.subscriptionPlanPrice?.visualTestingProAnnually
      ?? PlanPrice.VISUAL_TESTING_PRO_ANNUALLY,
    monthlyPrice: flags?.subscriptionPlanPrice?.visualTestingProMonthly
      ?? PlanPrice.VISUAL_TESTING_PRO_MONTHLY,
  },
];
